import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Head from '../../components/head';
import ItemBox from '../../components/itens/item';


function DiariasScreen() {
    return (
        <Fragment>
            <Head titulo="Diárias - Portal da Transparência da Prefeitura de Macuco" />
            <Header />
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />
                <Row xs={1} lg={2}>
                    <Col>
                        <ItemBox
                            titulo={"Despesas Diárias"}
                            descricao={<Fragment>Clique aqui e veja as diárias pagas no nosso município.<br /><br /></Fragment>}
                            awesome={"faCalendarDay"}
                            link={"https://macuco.govbr.cloud/pronimtb/index.asp?acao=3&item=11"}
                        />
                    </Col>
                    <Col>
                        <ItemBox
                            titulo={"Diárias de Viagens"}
                            descricao={<Fragment>Clique aqui e veja as diárias de viagens pagas em nosso município.<br /><br /></Fragment>}
                            awesome={"faPlaneDeparture"}
                            link={"https://macuco.govbr.cloud/pronimtb/index.asp?acao=3&item=15"}
                        />
                    </Col>
                    <Col>
                        <ItemBox
                            titulo={"Tabela de Diárias"}
                            descricao={<Fragment>Veja aqui lei a tabela de concessão de diárias aos servidores públicos de nosso município.<br /><br /></Fragment>}
                            awesome={"faTableList"}
                            link={"diarias/tabela"}
                        />
                    </Col>
                    <Col>
                        <ItemBox
                            titulo={"Lei 867/2019"}
                            descricao={<Fragment>Veja aqui lei que fixa as normas para concessão de diárias aos servidores públicos de nosso município.<br /><br /></Fragment>}
                            awesome={"faGavel"}
                            link={"arquivos/lei/2019/Lei867.pdf"}
                        />
                    </Col>
                </Row>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default DiariasScreen;